import axios from "axios";
import { clearLogoutData } from "../logout/action";
import { Partner_Service_URL } from "../Url";

export const saveThresholdChangeActions = {
  SAVE_THRESHOLD_CHANGE_SUCCESS: "SAVE_THRESHOLD_CHANGE_SUCCESS",
  SAVE_THRESHOLD_CHANGE_ERROR: "SAVE_THRESHOLD_CHANGE_ERROR",
};

export function saveThresholdChangeDetails(props) {
  const { access_token, values, partnerFirmId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/saveleadThresholdAllowBeforeRegistartion?partnerFirmId=${partnerFirmId}`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveThresholdChangeSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveThresholdChangeError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(saveThresholdChangeError(err));
          return err.response;
        }
      });
}

export function saveThresholdChangeError(error) {
  return {
    type: saveThresholdChangeActions.SAVE_THRESHOLD_CHANGE_ERROR,
    payload: error,
  };
}

export function saveThresholdChangeSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: saveThresholdChangeActions.SAVE_THRESHOLD_CHANGE_SUCCESS,
      payload: props,
    });
  };
}
